import Vue from 'vue'
import store from '../store'

function AddYearOrMonth (date, year = 0, month = 0) {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  let d = date.getDate()
  if (year > 0) {
    y = y + year
  }
  if (month > 0) {
    y = y + parseInt(month) / 12
    m = m + parseInt(month) % 12
  }
  m = m < 10 ? ('0' + m) : m
  d = d < 10 ? ('0' + d) : d
  return String(y) + String(m) + String(d)
}

function getSummary (param, propList, amountList = propList) {
  const {columns, data} = param
  const sums = []
  let values = []
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '合计'
      return
    }
    let propIndex = propList.indexOf(column.property)
    if (propIndex > -1) {
      values = data.map(item => Number(item[propList[propIndex]]))
      let temp = values.reduce((prev, curr) => {
        const value = Number(curr)
        if (!isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0)
      if (amountList.indexOf(column.property) > -1) {
        sums[index] = Vue.filter('AmountFormat')(temp)
      } else {
        sums[index] = temp
      }
    } else {
      sums[index] = '--'
    }
  })
  return sums
}

function handleSumData (list, field) {
  let tempList = list
  tempList.forEach((item) => {
    if (item[field] === '合计' || item[field] === '小计') {
      for (let key in item) {
        if (!item[key]) {
          item[key] = '--'
        }
      }
    }
  })
  return tempList
}

function judgeEvaluateScore (score) {
  let flag = score - store.state.applyBase.scoreLowest
  return flag > 0
}

function getTheFirstDay (date) {
  let fullDate = date + '01'
  return fullDate
}

function getTheLastDay (date) {
  let year = date.slice(0, 4)
  let month = date.slice(4, 6)
  let nextMonthFirstDay = new Date(year, month, 1)
  let oneDay = 1000 * 60 * 60 * 24
  let lastTime = new Date(nextMonthFirstDay - oneDay)
  let day = lastTime.getDate()
  return date + day
}

let handleFunc = {
  AddYearOrMonth,
  getSummary,
  judgeEvaluateScore,
  handleSumData,
  getTheFirstDay,
  getTheLastDay
}

export {handleFunc}



// WEBPACK FOOTER //
// ./src/util/applyBase_handleFunc.js